import { createSlice } from "@reduxjs/toolkit";
import { BusinessDetailsData } from "../types/VerBusinessDetailsType";
import { getCommunicationAddress } from "../action/getCommunicationAddress";

const initialState: BusinessDetailsData = {
  data: null,
  loading: false,
  error: null,
  successfull: false,
};

const verCommAddressDetailsSlice = createSlice({
  name: "verCommAddressDetailsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCommunicationAddress.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCommunicationAddress.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DATA createAppSlice", action);
      })
      .addCase(getCommunicationAddress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const verCommAddressDetailsReducer = verCommAddressDetailsSlice.reducer;
